<template>
  <section id="Dealer" class="mt-1 mb-2">
    <div class="text-right cursor--pointer pr-1" @click="closeTab()">
      <i class="fa fa-times-circle"></i> Sulje
    </div>
    <div class="form-group">
      <label for="jm" class="text-white">Jälleenmyyjä</label>
      <select name="jm" id="jm" v-model="selectedDealer">
        <option value="none">Ei valittu</option>
        <option v-for="jm in dealers" :key="jm.uuid" :value="jm.url.WebsiteURL">
          {{jm.name}}
        </option>
      </select>
      <p class="text-white mt-2">
        Valittuasi listasta jälleenmyyjän, sivusto näyttää lisäavarusteelle (pää)liikkeen hinnan.
      </p>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Dealer',
  props: {
    msg: String
  },

  data () {
    return {
      dealers: null,
      selectedDealer: 'none'
    }
  },

  watch: {
    selectedDealer () {
      if (Array.isArray(this.selectedDealer)) {
        let jm = this.selectedDealer[0]
        jm = jm.replace(/^https?:\/\//, '') // get rid of the http:// or https://
        jm = jm.replace(/\//g, '') // remove ending slash
        jm = jm.replace(/\./g, '') // remove dots

        this.$store.dispatch('updateDealer', jm)
      } else {
        this.$store.dispatch('updateDealer', this.selectedDealer)
      }
    }
  },

  mounted () {
    this.getDealers()
  },

  methods: {
    getDealers: function () {
      const headers = { headers: { Authorization: 'Bearer KWWae7MYKmEvW190EfaOmKDEZBhet5dkrEWOjy3QgnAWAwDTjE5qEAL65iR1' } }
      const self = this
      axios
        // .get('data.json')
        .get('https://a2d-proxy.lib.toyota.fi/api/data/by_name', headers)
        .then(response => (self.dealers = response.data))
        .catch(error => { console.log(error) })
    },

    closeTab: function () {
      this.$emit('closeTab', true)
    }
  }
}
</script>
